<template>
  <div>
    <van-nav-bar
      title="天津外研社教材查询"
      left-text=""
      left-arrow
      @click-left="goBackHomepage()"
    >
    </van-nav-bar>
    <van-form @submit="onSubmit">
      <van-row>
        <van-field
          readonly
          clickable
          :value="attributeValue"
          name="picker"
          label="词性"
          left-icon="wechat"
          placeholder="点击选择词性"
          @click="showPickerAttribute = true"
        />
      </van-row>
      <van-popup
        v-model="showPickerAttribute"
        position="bottom"
        :style="{ height: '70%' }"
      >
        <van-row type="flex" justify="space-between">
          <van-col span="4">
            <van-button type="default" size="normal" @click="attributeOnConfirm"
              >确定</van-button
            >
          </van-col>
          <van-col span="4">
            <van-button
              type="default"
              size="normal"
              @click="clearAttributeSelected"
              >清空</van-button
            >
          </van-col>
        </van-row>

        <van-row>
          <van-search
            v-model="valueAttribute"
            placeholder="输入词性（支持中英）"
            show-action
            input-align="center"
            @search="onSearchAttribute"
            @cancel="onCancelAttribute"
          />
        </van-row>
        <van-checkbox-group v-model="attributeSelected">
          <van-cell-group>
            <van-cell
              v-for="(attribute, index) in attributeColumns"
              clickable
              :key="attribute.英文"
              :title="`${attribute.中文 + ' ' + attribute.英文}`"
              @click="toggleAttribute(index)"
            >
              <template #right-icon>
                <van-checkbox :name="attribute" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
        <van-popup
          v-model="showPickerMiniAttribute"
          position="bottom"
          :style="{ height: '70%' }"
        >
          <div style="font-size: 16px; font-weight: bold; margin: 4%">
            选择词性
          </div>
          <van-checkbox-group
            style="margin: 2%"
            v-model="attributeMiniSelected"
          >
            <van-cell-group>
              <van-cell
                v-for="(attribute, index) in attributeMiniColumns"
                clickable
                :key="attribute.英文"
                :title="`${attribute.中文 + ' ' + attribute.英文}`"
                @click="toggleMiniAttribute(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="attribute" ref="checkboxesMini" />
                </template>
              </van-cell>
            </van-cell-group>
            <van-button
              style="margin-top: 2%"
              type="primary"
              block
              @click="attributeMiniOnConfirm"
              >确认</van-button
            >
          </van-checkbox-group>
        </van-popup>
      </van-popup>

      <initial-select ref="initialSelect"></initial-select>
      <text-book ref="textbook"></text-book>
    </van-form>
    <van-cell center title="按教材排序">
      <template #right-icon>
        <van-switch v-model="byBooks" size="24" />
      </template>
    </van-cell>

    <word-select ref="wordSelect"></word-select>
    <van-button
      style="margin-top: 5%; margin-left: 0.2%"
      type="primary"
      block
      round
      plain
      @click="filterData()"
      >筛选</van-button
    >
    <van-button
      style="margin-top: 2%; margin-left: 0.2%"
      type="danger"
      block
      round
      plain
      @click="filterClear(false)"
      >清空</van-button
    >
    <van-tag
      v-if="$store.state.tagShowWords"
      type="primary"
      style="margin-left: 73%; margin-top: 4%"
      size="medium"
      plain
      round
      @click="queryUpdate()"
      >点击更新词汇？</van-tag
    >
    <van-loading
      v-show="$store.state.loadingWords"
      style="margin-left: 67%; margin-top: 4%"
      type="spinner"
      text-size="12px"
      color="#1989fa"
      >单词加载中...
    </van-loading>
  </div>
</template>

<script>
import { Toast } from "vant";

import initialSelect from "./initialSelect.vue";
import TextBook from "@/components/textBook";
import wordSelect from "@/components/wordSelect";
import axios from "axios";
import { Base64 } from "js-base64";
import $ from "jquery";

export default {
  name: "filterWords",
  components: { TextBook, initialSelect, wordSelect },
  data() {
    return {
      // 词性
      attributeValue: "",
      attributeSelected: [],
      showPickerAttribute: false,
      attributeColumns: [
        { 英文: "v", 中文: "动词" },
        { 英文: "n", 中文: "名词" },
        { 英文: "pron", 中文: "代词" },
        { 英文: "adj", 中文: "形容词" },
        { 英文: "adv", 中文: "副词" },
        { 英文: "prep", 中文: "介词" },
        { 英文: "conj", 中文: "连词" },
        { 英文: "num", 中文: "数词" },
        { 英文: "exclaim", 中文: "感叹词" },
        { 英文: "article", 中文: "冠词" },
      ],
      // 搜索词性
      valueAttribute: "",
      showPopoverAttribute: false,

      attributeMiniColumns: [],
      attributeMiniSelected: [],
      showPickerMiniAttribute: false,
      // 排序
      byBooks: true,
    };
  },
  methods: {
    onSubmit() {},
    onClickLeft() {},
    goBackHomepage() {
      // this.$router.go(-1)
      this.$router.push({ name: "homepage", params: {} });
    },
    // 搜索词性
    attributeMiniOnConfirm() {
      // 二级搜索词性确认按钮
      this.showPickerMiniAttribute = false;
      this.attributeSelected = this.attributeMiniSelected;
      this.valueAttribute = "";
    },
    onCancelAttribute() {
      // 词性搜索取消按钮
      this.valueAttribute = "";
    },
    onSearchAttribute() {
      // 词性搜索确认回车
      let attributeColumnsNew = [];
      if (this.valueAttribute != "") {
        for (let i = 0; i < this.attributeColumns.length; i++) {
          if (
            this.attributeColumns[i]["中文"].indexOf(this.valueAttribute) !=
              -1 ||
            this.attributeColumns[i]["英文"].indexOf(this.valueAttribute) != -1
          ) {
            attributeColumnsNew.push(this.attributeColumns[i]);
          }
        }
        this.attributeMiniColumns = attributeColumnsNew;
      }
      this.showPickerMiniAttribute = true;
      // console.log('attributeColumnsNew', attributeColumnsNew)
    },
    toggleMiniAttribute(index) {
      this.$refs.checkboxesMini[index].toggle();
    },
    // 词性
    attributeOnConfirm() {
      // console.log(this.attributeSelected)
      let listAtrributeValue = [];
      for (let i = 0; i < this.attributeSelected.length; i++) {
        listAtrributeValue.push(this.attributeSelected[i]["中文"]);
      }
      // this.getAttributeValue(this.attributeSelected)
      this.getAttributeValue(listAtrributeValue);
      this.showPickerAttribute = false;
    },
    clearAttributeSelected() {
      this.attributeSelected = [];
      this.attributeValue = "";
    },
    toggleAttribute(index) {
      this.$refs.checkboxes[index].toggle();
    },
    getAttributeValue(attributeList) {
      if (attributeList.length > 0) {
        let attributeNumber = attributeList.length;
        if (attributeNumber == 1) {
          this.attributeValue = attributeList[0];
        }
        if (attributeNumber == 2) {
          this.attributeValue = attributeList[0] + "," + attributeList[1];
        }
        if (attributeNumber > 2) {
          this.attributeValue =
            attributeList[0] +
            "," +
            attributeList[1] +
            "等" +
            attributeNumber +
            "个";
        }
      }
    },
    // 判断英文还是中文
    judgeEnglish(value) {
      const regList = [
        { reg: /[\u4E00-\u9FA5]/, name: "中文" },
        { reg: /[^0-9]/, name: "英文" },
        { reg: /[^A-Za-z]/, name: "数字" },
      ];
      for (let i = 0; i < regList.length; i++) {
        if (regList[i].reg.test(value)) return regList[i].name;
      }
    },
    // 单词词组排序
    sortExpression(_arr) {
      // 字典自定义排序
      let sortArr1 = [
        "新七上",
        "新七下",
        "新八上",
        "新八下",
        "新九上",
        "新九下",
        "七上",
        "七下",
        "八上",
        "八下",
        "九上",
        "九下",
        "必修一",
        "必修二",
        "必修三",
        "选修一",
        "选修二",
      ];
      let sortArr2 = [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
      ];
      function getIndex(arr, key) {
        return arr.indexOf(key) != -1 ? arr.indexOf(key) : 10000;
      }
      _arr.sort(function (a, b) {
        if (getIndex(sortArr1, a.教材) == getIndex(sortArr1, b.教材)) {
          try {
            if (
              getIndex(sortArr2, a.模块.split(" ")[1]) >
              getIndex(sortArr2, b.模块.split(" ")[1])
            ) {
              return 1;
            } else if (
              getIndex(sortArr2, a.模块.split(" ")[1]) <
              getIndex(sortArr2, b.模块.split(" ")[1])
            ) {
              return -1;
            } else {
              return 0;
            }
          } catch (e) {
            return;
          }
        } else {
          return getIndex(sortArr1, a.教材) > getIndex(sortArr1, b.教材)
            ? 1
            : -1;
        }
      });
      // console.log(_arr);
      return _arr;
    },
    // 按钮
    filterData() {
      this.$yesnoFilter();

      // 首字母
      let fitlerResult1 = [];
      if (
        this.$store.state.initialSelected.length != 0 &&
        this.$store.state.initialSelected[0] != undefined
      ) {
        for (let i = 0; i < this.$store.state.newWords.length; i++) {
          for (let j = 0; j < this.$store.state.initialSelected.length; j++) {
            if (
              this.$store.state.initialSelected[j] ==
                this.$store.state.newWords[i]["英文"][0] &&
              this.$store.state.newWords[i]["词性"] != ""
            ) {
              let obj = {};
              obj["中文"] = this.$store.state.newWords[i]["中文"];
              obj["备注"] = this.$store.state.newWords[i]["备注"];
              obj["教材"] = this.$store.state.newWords[i]["教材"];
              obj["模块"] = this.$store.state.newWords[i]["模块"];
              obj["英文"] = this.$store.state.newWords[i]["英文"];
              obj["词性"] = this.$store.state.newWords[i]["词性"];
              fitlerResult1.push(obj);
            }
          }
        }
      } else {
        fitlerResult1 = this.$store.state.newWords;
      }

      // 词性
      let fitlerResult2 = [];
      let attributeSearch = "";
      if (this.attributeSelected.length != 0) {
        for (let i = 0; i < fitlerResult1.length; i++) {
          for (let j = 0; j < this.attributeSelected.length; j++) {
            if (fitlerResult1[i]["词性"] != "") {
              if (fitlerResult1[i]["词性"].search("/") == -1) {
                // 只有一个词性
                attributeSearch = fitlerResult1[i]["词性"];
                if (
                  this.attributeSelected[j]["英文"] == attributeSearch &&
                  fitlerResult1[i]["词性"]
                ) {
                  let obj = {};
                  obj["中文"] = fitlerResult1[i]["中文"];
                  obj["备注"] = fitlerResult1[i]["备注"];
                  obj["教材"] = fitlerResult1[i]["教材"];
                  obj["模块"] = fitlerResult1[i]["模块"];
                  obj["英文"] = fitlerResult1[i]["英文"];
                  obj["词性"] = fitlerResult1[i]["词性"];
                  fitlerResult2.push(obj);
                }
              } else {
                // 有多个词性
                attributeSearch = fitlerResult1[i]["词性"].split("/");
                for (let k = 0; k < attributeSearch.length; k++) {
                  if (
                    this.attributeSelected[j]["英文"] == attributeSearch[k] &&
                    fitlerResult1[i]["词性"] != NaN
                  ) {
                    let obj = {};
                    obj["中文"] = fitlerResult1[i]["中文"];
                    obj["备注"] = fitlerResult1[i]["备注"];
                    obj["教材"] = fitlerResult1[i]["教材"];
                    obj["模块"] = fitlerResult1[i]["模块"];
                    obj["英文"] = fitlerResult1[i]["英文"];
                    obj["词性"] = fitlerResult1[i]["词性"];
                    fitlerResult2.push(obj);
                  }
                }
              }
            }
          }
        }
      } else {
        fitlerResult2 = fitlerResult1;
      }

      let filterFinalTextbook;
      // 模块
      if (this.$store.state.textbookSelected.length != 0) {
        let fitlerResult3 = []; // 七上 (索引向后偏移两位至 6)
        const juniorOne =
          this.$store.state.textbookSelected[6]["juniorOneSelected"];
        if (juniorOne.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "七上" &&
              juniorOne.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult3.push(obj);
            }
          }
        }

        let fitlerResult03 = []; // 新七上
        const newjuniorOne =
          this.$store.state.textbookSelected[0]["newjuniorOneSelected"];
        if (newjuniorOne.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "新七上" &&
              newjuniorOne.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult03.push(obj);
            }
          }
        }

        let fitlerResult4 = []; // 七下 (索引向后偏移两位至 7)
        const juniorTwo =
          this.$store.state.textbookSelected[7]["juniorTwoSelected"];
        if (juniorTwo.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "七下" &&
              juniorTwo.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult4.push(obj);
            }
          }
        }

        let fitlerResult04 = []; // 新七下
        const newjuniorTwo =
          this.$store.state.textbookSelected[1]["newjuniorTwoSelected"];
        if (newjuniorTwo.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "新七下" &&
              newjuniorTwo.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult04.push(obj);
            }
          }
        }

        let fitlerResult5 = []; // 八上 (索引向后偏移两位至 8)
        const juniorThree =
          this.$store.state.textbookSelected[8]["juniorThreeSelected"];
        if (juniorThree.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "八上" &&
              juniorThree.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult5.push(obj);
            }
          }
        }

        let fitlerResult05 = []; // 新八上
        const newjuniorThree =
          this.$store.state.textbookSelected[2]["newjuniorThreeSelected"];
        if (newjuniorThree.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "新八上" &&
              newjuniorThree.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult05.push(obj);
            }
          }
        }

        let fitlerResult06 = []; // 新八下
        const newjuniorFour =
          this.$store.state.textbookSelected[3]["newjuniorFourSelected"];
        if (newjuniorFour.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "新八下" &&
              newjuniorFour.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult06.push(obj);
            }
          }
        }

        // ====== 新增：新九上 ======
        let fitlerResult07 = []; // 新九上 (对应索引 4)
        const newjuniorFive =
          this.$store.state.textbookSelected[4]["newjuniorFiveSelected"];
        if (newjuniorFive.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "新九上" &&
              newjuniorFive.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult07.push(obj);
            }
          }
        }

        // ====== 新增：新九下 ======
        let fitlerResult08 = []; // 新九下 (对应索引 5)
        const newjuniorSix =
          this.$store.state.textbookSelected[5]["newjuniorSixSelected"];
        if (newjuniorSix.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "新九下" &&
              newjuniorSix.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult08.push(obj);
            }
          }
        }

        let fitlerResult7 = []; // 八下 (索引向后偏移两位至 9)
        const juniorFour =
          this.$store.state.textbookSelected[9]["juniorFourSelected"];
        if (juniorFour.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "八下" &&
              juniorFour.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult7.push(obj);
            }
          }
        }

        let fitlerResult8 = []; // 九上 (索引向后偏移两位至 10)
        const juniorFive =
          this.$store.state.textbookSelected[10]["juniorFiveSelected"];
        if (juniorFive.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "九上" &&
              juniorFive.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult8.push(obj);
            }
          }
        }

        let fitlerResult9 = []; // 九下 (索引向后偏移两位至 11)
        const juniorSix =
          this.$store.state.textbookSelected[11]["juniorSixSelected"];
        if (juniorSix.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "九下" &&
              juniorSix.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult9.push(obj);
            }
          }
        }

        let fitlerResult10 = []; // 必修一 (索引向后偏移两位至 12)
        const seniorOne =
          this.$store.state.textbookSelected[12]["seniorOneSelected"];
        if (seniorOne.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "必修一" &&
              seniorOne.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult10.push(obj);
            }
          }
        }

        let fitlerResult11 = []; // 必修二 (索引向后偏移两位至 13)
        const seniorTwo =
          this.$store.state.textbookSelected[13]["seniorTwoSelected"];
        if (seniorTwo.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "必修二" &&
              seniorTwo.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult11.push(obj);
            }
          }
        }

        let fitlerResult12 = []; // 必修三 (索引向后偏移两位至 14)
        const seniorThree =
          this.$store.state.textbookSelected[14]["seniorThreeSelected"];
        if (seniorThree.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "必修三" &&
              seniorThree.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult12.push(obj);
            }
          }
        }

        let fitlerResult13 = []; // 选修一 (索引向后偏移两位至 15)
        const seniorFour =
          this.$store.state.textbookSelected[15]["seniorFourSelected"];
        if (seniorFour.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "选修一" &&
              seniorFour.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult13.push(obj);
            }
          }
        }

        let fitlerResult14 = []; // 选修二 (索引向后偏移两位至 16)
        const seniorFive =
          this.$store.state.textbookSelected[16]["seniorFiveSelected"];
        if (seniorFive.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "选修二" &&
              seniorFive.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult14.push(obj);
            }
          }
        }

        let fitlerResult15 = []; // 选修三 (索引向后偏移两位至 17)
        const seniorSix =
          this.$store.state.textbookSelected[17]["seniorSixSelected"];
        if (seniorSix.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "选修三" &&
              seniorSix.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult15.push(obj);
            }
          }
        }

        let fitlerResult16 = []; // 选修四 (索引向后偏移两位至 18)
        const seniorSeven =
          this.$store.state.textbookSelected[18]["seniorSevenSelected"];
        if (seniorSeven.length != 0) {
          for (let i = 0; i < fitlerResult2.length; i++) {
            if (
              fitlerResult2[i]["教材"] == "选修四" &&
              seniorSeven.indexOf(fitlerResult2[i]["模块"]) != -1
            ) {
              let obj = {};
              obj["中文"] = fitlerResult2[i]["中文"];
              obj["备注"] = fitlerResult2[i]["备注"];
              obj["教材"] = fitlerResult2[i]["教材"];
              obj["模块"] = fitlerResult2[i]["模块"];
              obj["英文"] = fitlerResult2[i]["英文"];
              obj["词性"] = fitlerResult2[i]["词性"];
              fitlerResult16.push(obj);
            }
          }
        }

        filterFinalTextbook = [
          ...fitlerResult3,
          ...fitlerResult4,
          ...fitlerResult5,
          ...fitlerResult03,
          ...fitlerResult04,
          ...fitlerResult05,
          ...fitlerResult06,
          ...fitlerResult07, // 增加了新九上
          ...fitlerResult08, // 增加了新九下
          ...fitlerResult7,
          ...fitlerResult8,
          ...fitlerResult9,
          ...fitlerResult10,
          ...fitlerResult11,
          ...fitlerResult12,
          ...fitlerResult13,
          ...fitlerResult14,
          ...fitlerResult15,
          ...fitlerResult16,
        ];
      } else {
        filterFinalTextbook = fitlerResult2;
      }

      // 排序
      let compare = function (prop) {
        return function (obj1, obj2) {
          let val1 = obj1[prop];
          let val2 = obj2[prop];
          if (val1 < val2) {
            return 1;
          } else if (val1 > val2) {
            return -1;
          } else {
            return 0;
          }
        };
      };
      let filterResult_final;
      const books = [
        "新七上",
        "新七下",
        "新八上",
        "新八下",
        "新九上", // 排序加上新九上
        "新九下", // 排序加上新九下
        "七上",
        "七下",
        "八上",
        "八下",
        "九上",
        "九下",
        "必修一",
        "必修二",
        "必修三",
        "选修一",
        "选修二",
        "选修三",
        "选修四",
      ];
      const modules = [
        "Module 1",
        "Module 2",
        "Module 3",
        "Module 4",
        "Module 5",
        "Module 6",
        "Revision Module A",
        "Module 7",
        "Module 8",
        "Module 9",
        "Module 10",
        "Module 11",
        "Module 12",
        "Revision Module B",
        "Unit 1",
        "Unit 2",
        "Unit 3",
        "Unit 4",
        "Unit 5",
        "Unit 6",
      ];
      const p = [books, modules];
      if (this.byBooks) {
        // 教材排序
        filterResult_final = this.commonApi.ForwardRankingData(
          filterFinalTextbook,
          p
        );
      } else {
        // 备注靠前
        filterResult_final = filterFinalTextbook.sort(compare("备注"));
        if (
          this.$store.state.initialSelected.length == 0 &&
          this.$store.state.initialSelected[0] == undefined
        ) {
          this.$refs.wordSelect.sortExpression(filterResult_final);
        }
      }

      this.$store.state.filterResult = filterResult_final;
      // 跳转
      if (filterResult_final.length != 0) {
        let res = new Promise((resolve, reject) => {
          this.$router.push({ name: "wordsList", params: {} });
          resolve("ok");
        });
        res.then((res) => {
          Toast.success("共" + this.$store.state.filterResult.length + "条");
        });
        // 清除
        this.filterClear(this.$store.state.checkedTextbookSave);
        console.log('textbookSelected', this.$store.state.textbookSelected);
      } else {
        Toast.fail("未查到单词");
      }
    },
    filterClear(checkedTextbookSave = true) {
      this.attributeValue = "";
      this.attributeSelected = [];
      if (checkedTextbookSave == false) {
        this.$refs.textbook.clearTextbook();
      }
      this.$refs.initialSelect.clearInitialSelected();
    },
    // 更新教材数据
    queryUpdate() {
      let newWordsData = new Promise((resolve, reject) => {
        this.$store.state.tagShowWords = false;
        this.$store.state.loadingWords = true;
        resolve(this.commonApi.getNewWords());
      });
      newWordsData = newWordsData.then((newWordsData) => {
        this.$store.state.loadingWords = false;
        this.$store.state.newWords = newWordsData["data"];
        localStorage.removeItem("newWords");
        return newWordsData;
      });
      newWordsData.then((newWordsData) => {
        localStorage.setItem(
          "newWords",
          Base64.encode(JSON.stringify(newWordsData))
        );
        Toast.success("更新成功");
      });
    },
    // 判断是否更新数据
    ifUpdate() {
      async function queryifUpdate() {
        let params = new URLSearchParams();
        params.append("method", "newWords");
        params.append(
          "version",
          JSON.parse(Base64.decode(localStorage.getItem("newWords")))["version"]
        );
        return await axios.post("ifUpdate/", params).then((ret) => {
          return ret.data;
        });
      }
      let res = new Promise((resolve, reject) => {
        resolve(queryifUpdate());
      });
      res.then((res) => {
        if (res == true) this.$store.state.tagShowWords = true;
      });
    },
  },
  activated() {
    this.attributeSelected = [];
    this.$store.state.initialSelected = [];
    this.$store.state.filterResult = [];
  },
  mounted() {
    if (localStorage.getItem("newWords") != null) this.ifUpdate();
  },
};
</script>

<style scoped>
.fade-leave-to {
  opacity: 0;
  transform: translate3d(0, 30px, 0);
  position: absolute;
  z-index: -10;
}
.fade-enter {
  transform: translate3d(0, 0px, 0);
  position: absolute;
}
.fade-leave-active {
  transition: 2.5s all ease;
}
.fade-enter-active {
  transition: opacity 1.5s;
}
</style>